import React from 'react'
import { Product } from 'models/Product'
import { DescriptionRoot } from './Description.styles'
import { Text } from 'components/Text'

type DescriptionProps = {
  productDescription: Product['description']
}

export const Description = ({ productDescription }: DescriptionProps) => {
  return (
    <DescriptionRoot>
      <Text
        size="headline"
        color="primary-800"
        dangerouslySetInnerHTML={{ __html: productDescription.enUS }}
      />
      {/* TODO: Language shouldn't be hardcoded */}
    </DescriptionRoot>
  )
}

Description.displayName = 'Description'
